import {useTranslation} from "react-i18next";
import Form from "react-bootstrap/Form";
import {useRef, useState, useEffect} from "react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
// -
import TableWarnings from "../import/TableWarnings";

const TabResult = ({props}) => {
    const {t: _Tf} = useTranslation("forms");

    const [warningsShow, setWarningsShow] = useState([]);
    // const roomID = useRef("");
    const [verifiedStatus, setVerifiedStatus] = useState(false);
    const [importedStatus, setImportedStatus] = useState(false);
    const [warningsCount, setWarningsCount] = useState(0);

    const resultData = useRef({
        // devices
        news: {
            actives: 0,
            devices: 0,
        },
        // containers
        updated: {
            actives: 0,
            devices: 0,
        },
        // counter
        counter: {
            actives: 0,
            devices: 0,
        },
        error: "",
        warnings: 0,
        routes: {
            news: 0,
            multi: 0,
        },
        islands: 0,
        groups: 0,
    });

    useEffect(() => {
        if (props && props.properties) {
            if (props.properties.result) {
                resultData.current = props.properties.result;
                setWarningsCount(props.properties.result.warnings || 0);
            }

            if (props.properties.warnings && props.properties.warnings.messages) {
                setWarningsShow(props.properties.warnings.messages);
            }

            setVerifiedStatus(props.properties.verified || false);
            setImportedStatus(props.properties.imported || false);
        }
    }, [props]);

    // console.log("TabResult", props.properties.result);

    return (
        <div className="row">
            <div className="col-md-10 col-12 m-auto">
                <div className="row">
                    <div className="col-md-12">
                        {/* <div className="col-12 text-center">
                            <h1>
                                {t("labels.devices")}:{" "}
                                {resultData.current.counter.actives || 0} / Contenedores{" "}
                                {resultData.current.counter.devices || 0}
                            </h1>
                        </div> */}
                        <div className="row mt-4 ">
                            {/* Nueva columna con estado de verificación e importación */}
                            <div className="col-md-4 text-center">
                                <h4>{_Tf("labels.status")}</h4>
                                <FontAwesomeIcon
                                    icon="clipboard"
                                    className="fa-2x mt-2"
                                />
                                <div className="col-12 d-flex justify-content-center mt-4 ">
                                    <table>
                                        <tbody>
                                            <tr>
                                                <td className="text-end border-0">
                                                    <h5>{_Tf("labels.verified")}:</h5>
                                                </td>
                                                <td className="text-end border-0 ps-3">
                                                    <h5>
                                                        {verifiedStatus ? (
                                                            <FontAwesomeIcon
                                                                icon="check"
                                                                className="text-success"
                                                            />
                                                        ) : (
                                                            <FontAwesomeIcon
                                                                icon="times"
                                                                className="text-danger"
                                                            />
                                                        )}
                                                    </h5>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td className="text-end border-0">
                                                    <h5>{_Tf("labels.imported")}:</h5>
                                                </td>
                                                <td className="text-end border-0 ps-3">
                                                    <h5>
                                                        {importedStatus ? (
                                                            <FontAwesomeIcon
                                                                icon="check"
                                                                className="text-success"
                                                            />
                                                        ) : (
                                                            <FontAwesomeIcon
                                                                icon="times"
                                                                className="text-danger"
                                                            />
                                                        )}
                                                    </h5>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td className="text-end border-0">
                                                    <h5>{_Tf("common.warnings")}:</h5>
                                                </td>
                                                <td className="text-end border-0 ps-3">
                                                    <h5>{warningsCount}</h5>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>

                            <div className="col-md-4 text-center">
                                <h4>{_Tf("labels.news")}</h4>
                                <FontAwesomeIcon
                                    icon="square-check"
                                    className="fa-2x mt-2"
                                />
                                <div className="col-12 d-flex justify-content-center mt-4">
                                    <table>
                                        <tbody>
                                            <tr>
                                                <td className="text-end border-0">
                                                    <h5>{_Tf("labels.devices")}:</h5>
                                                </td>
                                                <td className="text-end border-0 ps-3">
                                                    <h5>
                                                        {resultData.current.news
                                                            .devices || 0}
                                                    </h5>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td className="text-end border-0">
                                                    <h5>{_Tf("labels.containers")}:</h5>
                                                </td>
                                                <td className="text-end border-0 ps-3">
                                                    <h5>
                                                        {resultData.current.news
                                                            .actives || 0}
                                                    </h5>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td className="text-end border-0">
                                                    <h5>{_Tf("routes.routes")}:</h5>
                                                </td>
                                                <td className="text-end border-0 ps-3">
                                                    <h5>
                                                        {resultData.current.routes
                                                            .news || 0}
                                                    </h5>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td className="text-end border-0">
                                                    <h5>{_Tf("labels.islands")}:</h5>
                                                </td>
                                                <td className="text-end border-0 ps-3">
                                                    <h5>
                                                        {resultData.current.islands ||
                                                            0}
                                                    </h5>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td className="text-end border-0">
                                                    <h5>{_Tf("labels.groups")}:</h5>
                                                </td>
                                                <td className="text-end border-0 ps-3">
                                                    <h5>
                                                        {resultData.current.groups || 0}
                                                    </h5>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div className="col-md-4 text-center">
                                <h4>{_Tf("labels.updated")}</h4>
                                <FontAwesomeIcon icon="edit" className="fa-2x mt-2" />
                                <div className="col-12 d-flex justify-content-center mt-4">
                                    <table>
                                        <tbody>
                                            <tr>
                                                <td className="text-end border-0">
                                                    <h5>{_Tf("labels.devices")}:</h5>
                                                </td>
                                                <td className="text-end border-0 ps-3">
                                                    <h5>
                                                        {resultData.current.updated
                                                            .devices || 0}
                                                    </h5>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td className="text-end border-0">
                                                    <h5>{_Tf("labels.containers")}:</h5>
                                                </td>
                                                <td className="text-end border-0 ps-3">
                                                    <h5>
                                                        {resultData.current.updated
                                                            .actives || 0}
                                                    </h5>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>

                    {resultData.current.error && (
                        <div className="col-md-12 mt-5">
                            <div className="alert alert-danger">
                                {resultData.current.error}
                            </div>
                        </div>
                    )}

                    <div className="col-md-12">
                        {warningsShow.length > 0 ? (
                            <TableWarnings items={warningsShow} />
                        ) : (
                            <div className="alert alert-info text-center">
                                "No {_Tf("common.warnings")}
                            </div>
                        )}
                    </div>

                    <div className="col-md-12 mt-3 text-center">
                        <p>
                            <small>
                                {_Tf("common.size")}: {props.properties.size || "0 KB"}{" "}
                                | Email: {props.properties.email || ""} |{" "}
                                {_Tf("organization.date")}:{" "}
                                {props.properties.ended || ""}
                            </small>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default TabResult;
